<template>
  <v-container class="text-center" :style="backgroundStyle">
    <v-row>
      <v-col>
        <br/>
        <img :src="app.appLogo" width="120" style="border-radius:10px" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn @click="downloadApp" depressed block rounded large>
          <v-icon>mdi-apple</v-icon>
          <span style="margin-left:6px;">App Store</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-show="app.isShowLogin">
      <v-col>
        <v-btn @click="showLogin" text large>
          <v-icon>mdi-lock</v-icon>
          <span style="margin-left:6px;">LOGIN</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
.v-content, .v-content__wrap, .container{
  height: 100%;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',
  data: function () {
    return {
      backgroundStyle: 'background-image:url(' + process.env.BASE_URL + 'images/index-bg.png);background-size:100% 100%'
    }
  },
  computed: {
    ...mapState([ "app" ]),
  },
  beforeMount() {
    //console.log('[D]NODE_ENV: ' + process.env.NODE_ENV)
    this.$emit("app_info", 'ミーティアLive', false, false);
  },
  methods: {
    downloadApp() {
      window.open(this.app.iosDownloadUrl)
    },
    showLogin() {
      this.$router.push('/login');
    }
  }
}
</script>
